import React from 'react';
import WinampEmbedPlayer from './WinampEmbedPlayer';
import './Spotify.css';

const Spotify = () => {
  // Your Spotify Playlist ID
  // Get it from: https://open.spotify.com/playlist/YOUR_PLAYLIST_ID
  const PLAYLIST_ID = '6XVpCkUrFHDJb9Nxio2U0K';

  return (
    <div className="spotify-container">
      <WinampEmbedPlayer playlistUri={PLAYLIST_ID} />
    </div>
  );
};

export default Spotify;